import React, { useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import { IFS_AI_PROMPT } from '../content/prompt';
import { useLang, T } from '../lib/lang';

export function PromptSection() {
  const { lang } = useLang();
  const [copied, setCopied] = useState(false);

  const text = useMemo(() => (lang === 'ru' ? IFS_AI_PROMPT.ru : IFS_AI_PROMPT.en), [lang]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // ignore
    }
  };

  return (
    <section id="prompt" className="border-b border-border py-20">
      <div className="mx-auto max-w-6xl px-6">
        <div className="mb-10">
          <div className="text-[10px] uppercase tracking-[0.25em] text-dim">
            <T ru="prompt" en="prompt" />
          </div>
          <h2 className="mt-3 font-serif text-3xl font-light italic text-text md:text-4xl">
            <T ru="надёжный суфлёр" en="reliable prompter" />
          </h2>
          <p className="mt-4 max-w-3xl text-sm leading-7 text-muted">
            <T
              ru="базовый системный промпт для IFS + AI: короткий, практичный, с фокусом на Self и уважением к защитам."
              en="a baseline system prompt for IFS + AI: short, practical, Self-centered, respectful to protectors."
            />
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="overflow-hidden rounded-xl border border-border bg-card"
        >
          <div className="flex items-center justify-between border-b border-border bg-bg/40 px-5 py-4 backdrop-blur">
            <div className="text-[10px] uppercase tracking-widest text-muted">
              <T ru="system prompt" en="system prompt" />
            </div>
            <button
              type="button"
              onClick={copy}
              className="rounded border border-border px-3 py-1 text-[10px] uppercase tracking-widest text-text transition-colors hover:border-gold hover:text-gold"
            >
              {copied ? <T ru="скопировано" en="copied" /> : <T ru="копировать" en="copy" />}
            </button>
          </div>

          <pre className="max-h-[520px] overflow-auto p-5 text-[12px] leading-6 text-muted">
            <code>{text}</code>
          </pre>
        </motion.div>
      </div>
    </section>
  );
}
